import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CostEventItemsDataGrid } from "src/components/views/erp/common/costEvents/CostEventItemsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/common/costEvents")({
	staticData: { title: i18n.t("items"), legacyViewKey: "costEventItemPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CostEventItemsDataGrid />;
}
